import { v4 as uuid } from 'uuid';

import type { ImageItem } from 'hb-builder/components/BuilderComponents/block/Strips/types/items';
import type { FeatureConfig } from 'hb-builder/types';

export const INITIAL_STRIPS_IMAGES = ({
  features,
}: {
  features: FeatureConfig;
}): ImageItem[] =>
  [
    {
      attributes: {
        url: features.panel.inPanel
          ? '/images/missing/image_galleries/low_quality_images/Img_1.jpg'
          : '/images/missing/image_galleries/hight_quality_images/img7.jpeg',
        alt: '',
        position: 'center',
        clickable: true,
      },
    },
    {
      attributes: {
        url: features.panel.inPanel
          ? '/images/missing/image_galleries/low_quality_images/Img_6.jpg'
          : '/images/missing/image_galleries/hight_quality_images/img2.jpeg',
        alt: '',
        position: 'center',
        clickable: true,
      },
    },
    {
      attributes: {
        url: features.panel.inPanel
          ? '/images/missing/image_galleries/low_quality_images/Img.jpg'
          : '/images/missing/image_galleries/hight_quality_images/img8.jpeg',
        alt: '',
        position: 'center',
        clickable: true,
      },
    },
    {
      attributes: {
        url: features.panel.inPanel
          ? '/images/missing/image_galleries/low_quality_images/Img_7.jpg'
          : '/images/missing/image_galleries/hight_quality_images/img1.jpeg',
        alt: '',
        position: 'center',
        clickable: true,
      },
    },
    {
      attributes: {
        url: features.panel.inPanel
          ? '/images/missing/image_galleries/low_quality_images/Img_3.jpg'
          : '/images/missing/image_galleries/hight_quality_images/img6.jpeg',
        alt: '',
        position: 'center',
        clickable: true,
      },
    },
    {
      attributes: {
        url: features.panel.inPanel
          ? '/images/missing/image_galleries/low_quality_images/Img_2.jpg'
          : '/images/missing/image_galleries/hight_quality_images/img5.jpeg',
        alt: '',
        position: 'center',
        clickable: true,
      },
    },
  ].map((item) => ({
    ...item,
    id: uuid(),
    type: 'StripImage',
  }));

export const INITIAL_STRIPS_SLIDER = {
  numberOfItems: '4',
  button: {},
  fields: {
    displayButton: true,
    displayImage: true,
    displayHeadline: true,
    displaySubline: true,
  },
  headline: {},
  sublime: {},
};
